// Mock data for DYC MARKETING SDN BHD Food Supply Landing Page

export const companyInfo = {
  name: 'DYC MARKETING SDN BHD Marketing Sdn Bhd',
  registrationNumbers: '202501035841 (1637251-D)',
  logo: 'https://customer-assets.emergentagent.com/job_DYC MARKETING SDN BHD-wholesale/artifacts/00c0pyue_DYC MARKETING SDN BHD_Logo_Transparent%20%281%29.png'
};

export const contactInfo = {
  phone: '+60 16-218 5360',
  email: 'www.dyc.com.my',
  website: 'www.dyc.com.myD.com.my',
  whatsapp: '+60162185360',
  contactPerson: 'Mr. Han',
  address: 'Kuala Lumpur, Malaysia',
  mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127506.05841632857!2d101.58469285!3d3.1319197!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc49c701efeae7%3A0xf4d98e5b2f1c287d!2sKuala%20Lumpur%2C%20Federal%20Territory%20of%20Kuala%20Lumpur%2C%20Malaysia!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s'
};

export const products = [
  {
    id: 1,
    name: 'Meat',
    icon: 'Beef',
    description: 'Premium quality beef, chicken, lamb, mutton, and poultry',
    image: 'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?q=80&w=1200&auto=format&fit=crop',
    categories: ['Beef', 'Chicken', 'Lamb', 'Mutton', 'Poultry'],
    items: [
      { name: 'Beef', description: 'Fresh premium beef cuts', image: 'https://images.unsplash.com/photo-1603048297172-c92544798d5a?q=80&w=800&auto=format&fit=crop' },
      { name: 'Chicken', description: 'Whole chicken and portions', image: 'https://images.unsplash.com/photo-1587593810167-a84920ea0781?q=80&w=800&auto=format&fit=crop' },
      { name: 'Lamb', description: 'Tender lamb cuts', image: 'https://images.unsplash.com/photo-1602470521006-b9c5cff5eda9?q=80&w=800&auto=format&fit=crop' },
      { name: 'Mutton', description: 'Quality mutton meat', image: 'https://images.unsplash.com/photo-1588347818481-c7c1e6460b28?q=80&w=800&auto=format&fit=crop' },
      { name: 'Duck', description: 'Fresh whole duck', image: 'https://images.unsplash.com/photo-1580217593608-61931cefc821?q=80&w=800&auto=format&fit=crop' },
      { name: 'Poultry', description: 'Various poultry selections', image: 'https://images.unsplash.com/photo-1544736779-11c0f8f5df2f?q=80&w=800&auto=format&fit=crop' }
    ]
  },
  {
    id: 2,
    name: 'Seafood',
    icon: 'Fish',
    description: 'Fresh fish, prawns, crabs, and shellfish',
    image: 'https://images.unsplash.com/photo-1615141982883-c7ad0e69fd62?q=80&w=1200&auto=format&fit=crop',
    categories: ['Fish', 'Prawns', 'Crabs', 'Squid', 'Mussels', 'Shellfish'],
    items: [
      { name: 'Fish', description: 'Fresh whole fish varieties', image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=800&auto=format&fit=crop' },
      { name: 'Prawns', description: 'Large fresh prawns', image: 'https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?q=80&w=800&auto=format&fit=crop' },
      { name: 'Crabs', description: 'Live and fresh crabs', image: 'https://images.unsplash.com/photo-1580959375944-abd7e991f971?q=80&w=800&auto=format&fit=crop' },
      { name: 'Squid', description: 'Fresh whole squid', image: 'https://images.unsplash.com/photo-1626200419199-391ae4be7a41?q=80&w=800&auto=format&fit=crop' },
      { name: 'Mussels', description: 'Fresh mussels and clams', image: 'https://images.unsplash.com/photo-1559737558-2f5a35f4523b?q=80&w=800&auto=format&fit=crop' },
      { name: 'Shellfish', description: 'Assorted shellfish', image: 'https://images.unsplash.com/photo-1559737558-2f5a35f4523b?q=80&w=800&auto=format&fit=crop' }
    ]
  },
  {
    id: 3,
    name: 'Vegetables',
    icon: 'Salad',
    description: 'Farm-fresh vegetables and leafy greens',
    image: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?q=80&w=1200&auto=format&fit=crop',
    categories: ['Leafy Greens', 'Root Vegetables', 'Fresh Herbs'],
    items: [
      { name: 'Cabbage', description: 'Fresh green cabbage', image: 'https://images.unsplash.com/photo-1594282486552-05b4d80fbb9f?q=80&w=800&auto=format&fit=crop' },
      { name: 'Carrot', description: 'Sweet fresh carrots', image: 'https://images.unsplash.com/photo-1447175008436-054170c2e979?q=80&w=800&auto=format&fit=crop' },
      { name: 'Broccoli', description: 'Fresh green broccoli', image: 'https://images.unsplash.com/photo-1459411552884-841db9b3cc2a?q=80&w=800&auto=format&fit=crop' },
      { name: 'Lettuce', description: 'Crisp fresh lettuce', image: 'https://images.unsplash.com/photo-1622205313162-be1d5712a43f?q=80&w=800&auto=format&fit=crop' },
      { name: 'Tomato', description: 'Ripe red tomatoes', image: 'https://images.unsplash.com/photo-1592841200221-a6898f307baa?q=80&w=800&auto=format&fit=crop' },
      { name: 'Cucumber', description: 'Fresh crisp cucumbers', image: 'https://images.unsplash.com/photo-1568584711075-3d021a7c3ca3?q=80&w=800&auto=format&fit=crop' },
      { name: 'Onion', description: 'Yellow and red onions', image: 'https://images.unsplash.com/photo-1580201092675-a0a6a6cafbb1?q=80&w=800&auto=format&fit=crop' },
      { name: 'Potato', description: 'Fresh potatoes', image: 'https://images.unsplash.com/photo-1518977676601-b53f82aba655?q=80&w=800&auto=format&fit=crop' }
    ]
  },
  {
    id: 4,
    name: 'Fruits',
    icon: 'Apple',
    description: 'Seasonal and tropical fruits',
    image: 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?q=80&w=1200&auto=format&fit=crop',
    categories: ['Tropical', 'Seasonal', 'Watermelon', 'Banana'],
    items: [
      { name: 'Banana', description: 'Sweet ripe bananas', image: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?q=80&w=800&auto=format&fit=crop' },
      { name: 'Apple', description: 'Fresh crisp apples', image: 'https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?q=80&w=800&auto=format&fit=crop' },
      { name: 'Orange', description: 'Juicy fresh oranges', image: 'https://images.unsplash.com/photo-1547514701-42782101795e?q=80&w=800&auto=format&fit=crop' },
      { name: 'Watermelon', description: 'Sweet ripe watermelon', image: 'https://images.unsplash.com/photo-1571575173700-afb9492e6a50?q=80&w=800&auto=format&fit=crop' },
      { name: 'Grapes', description: 'Fresh table grapes', image: 'https://images.unsplash.com/photo-1537640538966-79f369143f8f?q=80&w=800&auto=format&fit=crop' },
      { name: 'Pineapple', description: 'Sweet tropical pineapple', image: 'https://images.unsplash.com/photo-1550258987-190a2d41a8ba?q=80&w=800&auto=format&fit=crop' },
      { name: 'Mango', description: 'Sweet tropical mangoes', image: 'https://images.unsplash.com/photo-1553279768-865429fa0078?q=80&w=800&auto=format&fit=crop' },
      { name: 'Papaya', description: 'Ripe fresh papaya', image: 'https://images.unsplash.com/photo-1517282009859-f000ec3b26fe?q=80&w=800&auto=format&fit=crop' }
    ]
  },
  {
    id: 5,
    name: 'Groceries',
    icon: 'ShoppingBasket',
    description: 'Dry goods, condiments, eggs, and pantry essentials',
    image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?q=80&w=1200&auto=format&fit=crop',
    categories: ['Dry Goods', 'Condiments', 'Oils', 'Spices', 'Eggs'],
    items: [
      { name: 'Rice', description: 'Premium quality rice', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?q=80&w=800&auto=format&fit=crop' },
      { name: 'Cooking Oil', description: 'Vegetable cooking oil', image: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?q=80&w=800&auto=format&fit=crop' },
      { name: 'Sugar', description: 'Refined white sugar', image: 'https://images.unsplash.com/photo-1610065057103-d0dc61fdcf9c?q=80&w=800&auto=format&fit=crop' },
      { name: 'Flour', description: 'All-purpose wheat flour', image: 'https://images.unsplash.com/photo-1608198093002-ad4e005484ec?q=80&w=800&auto=format&fit=crop' },
      { name: 'Salt', description: 'Table and cooking salt', image: 'https://images.unsplash.com/photo-1518110925495-b37653c33d24?q=80&w=800&auto=format&fit=crop' },
      { name: 'Canned Food', description: 'Assorted canned goods', image: 'https://images.unsplash.com/photo-1587049352846-4a222e784ec4?q=80&w=800&auto=format&fit=crop' },
      { name: 'Seasoning', description: 'Herbs and seasonings', image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=800&auto=format&fit=crop' },
      { name: 'Eggs', description: 'Fresh farm eggs', image: 'https://images.unsplash.com/photo-1607690424560-7e57c8e9d40e?q=80&w=800&auto=format&fit=crop' }
    ]
  },
  {
    id: 6,
    name: 'Frozen Food',
    icon: 'Snowflake',
    description: 'Frozen meats, seafood, and ready-to-cook items',
    image: 'https://customer-assets-jt897jd0.emergentagent.net/wingman/b9de27ed-8773-488a-a563-4c1c0e59b6b2/attachments/3cd4101cb3a04ded88de76ebf377b2e8_image.png',
    categories: ['Frozen Meat', 'Frozen Seafood', 'Ready Meals', 'Popia'],
    items: [
      { name: 'Frozen Chicken', description: 'Whole and portioned', image: 'https://images.unsplash.com/photo-1587593810167-a84920ea0781?q=80&w=800&auto=format&fit=crop' },
      { name: 'Frozen Seafood', description: 'Frozen fish and prawns', image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=800&auto=format&fit=crop' },
      { name: 'Nuggets', description: 'Ready-to-cook nuggets', image: 'https://images.unsplash.com/photo-1562967914-608f82629710?q=80&w=800&auto=format&fit=crop' },
      { name: 'French Fries', description: 'Frozen french fries', image: 'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?q=80&w=800&auto=format&fit=crop' },
      { name: 'Sausages', description: 'Assorted sausages', image: 'https://images.unsplash.com/photo-1601924582970-9238bcb495d9?q=80&w=800&auto=format&fit=crop' },
      { name: 'Frozen Vegetables', description: 'Mixed frozen vegetables', image: 'https://images.unsplash.com/photo-1615485500704-8e990f9900f7?q=80&w=800&auto=format&fit=crop' },
      { name: 'Popia', description: 'Frozen spring rolls', image: 'https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=800&auto=format&fit=crop' },
      { name: 'Ready Meals', description: 'Convenient ready-to-eat', image: 'https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=800&auto=format&fit=crop' }
    ]
  }
];

export const benefits = [
  {
    id: 1,
    icon: 'BadgeDollarSign',
    title: 'Competitive Price',
    description: 'Best wholesale pricing for bulk orders with transparent quotations'
  },
  {
    id: 2,
    icon: 'Warehouse',
    title: 'Large Cold Storage',
    description: 'State-of-the-art cold storage facilities ensuring product freshness'
  },
  {
    id: 3,
    icon: 'Truck',
    title: 'Fast Delivery',
    description: 'Reliable next-day delivery service across the region'
  },
  {
    id: 4,
    icon: 'ShieldCheck',
    title: 'Quality Assured',
    description: 'Stringent quality control measures to ensure product freshness and safety'
  }
];

export const clients = [
  { id: 1, icon: 'UtensilsCrossed', name: 'Restaurants', count: '50+' },
  { id: 2, icon: 'Coffee', name: 'Cafes', count: '30+' },
  { id: 3, icon: 'School', name: 'Schools', count: '10+' },
  { id: 4, icon: 'ChefHat', name: 'Catering', count: '15+' }
];

export const heroImages = [
  'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d',
  'https://images.unsplash.com/photo-1553413077-190dd305871c'
];
